<script>  
  import { noteStore, clientStore, scanStore, dataStore, transactionStore } from '../../stores'
  import { onDestroy, onMount } from 'svelte';
  import AddScanModal from '../scans/AddScanModal.svelte'
  import AddTransactionModal from '../transactions/AddTransaction.svelte'
  import AddNoteModal from '../notes/AddNoteModal.svelte'
  import EditScanModal from '../scans/EditScanModal.svelte'
  import EditNoteModal from '../notes/EditNoteModal.svelte'
  import EditTransactionModal from '../transactions/EditTransactionModal.svelte';
  import { config } from '../../../scripts/defaultURL';
  import { formatDate, formatPhone, openModal } from '../../../scripts/functions';
  import { getData, updateData } from '../../../scripts/rest';
  import DeleteClientModal from './DeleteClient.svelte';

  export let clientItem;

  $: if ($scanStore && $scanStore.todo == 'getData') {
    getData(`${config.defaultURL}/scans/${clientItem.id}`).then((data) => {
      scansInitialized = true;
      scanSelected = false;

      scans = data.sort((a,b) => {
        return new Date(b.date) - new Date(a.date);
      });
      
      if (!$dataStore) $dataStore = {};
      $dataStore['scans'] = scans;

      $scanStore.todo = null;

      console.log('Scans:',scans);
    });
  }

  $: if ($transactionStore && $transactionStore.todo == 'getData') {
    getData(`${config.defaultURL}/transactions`).then((data) => {
      transactionsInitialized = true;
      transactionSelected = false;

      transactions = data.sort((a,b) => {
        return new Date(b.date) - new Date(a.date);
      });

      clientTransactions = transactions.filter((item) => item.client_id == clientItem.id);      

      if (!$dataStore) $dataStore = {};
      $dataStore['transactions'] = transactions;

      $transactionStore.todo = null;
      
      console.log('transactions:',transactions);

      genTransactionCategories();
    });
  }

  $: if ($clientStore && $clientStore.todo == 'getData') displayClientDetails();

  $: if ($noteStore && $noteStore.todo == 'getData') {
    getData(`${config.defaultURL}/notes/${clientItem.id}`).then((data) => {
      $noteStore.todo = null;
      notesInitialized = true;
      noteSelected = false;

      notes = data.sort((a,b) => {
        return new Date(b.date) - new Date(a.date);
      });
      
      if (!$dataStore) $dataStore = {};
      $dataStore['notes'] = notes;
      
      console.log('Notes:',notes);
    });
  }

  let dataId;
  let scan;
  let scans;
  let scansInitialized = false;
  let scanSelected = false;
  let note;
  let notes;
  let notesInitialized = false;
  let noteSelected = false;
  let transactionSelected = false;
  let transaction;
  let transactions;
  let clientTransactions;
  let transactionCategories;
  let transactionsInitialized = false;
  let openDeleteClientModal = false;
  
  const payload = {
    first: clientItem.first || $clientStore.client.first,
    last: clientItem.last || $clientStore.client.last,
    email: clientItem.email || $clientStore.client.email,
    street: clientItem.street || $clientStore.client.street,
    city: clientItem.city || $clientStore.client.city,
    state: clientItem.state || $clientStore.client.state,
    zip: clientItem.zip || $clientStore.client.zip,
    phone: clientItem.phone || $clientStore.client.phone,
    dob: clientItem.dob || $clientStore.client.dob
  };

  onMount(() => {
    displayClientDetails();
  });

  onDestroy(() => {
    clientItem = null;
    openModal('clientDetailsModal');
  });

  function displayClientDetails() {
    console.log('displayClientDetails');

    if (!$scanStore) $scanStore = {};
    
    if ($dataStore.scans) $dataStore.scans = null;
    getData(`${config.defaultURL}/scans/${clientItem.id}`).then((data) => {
      scansInitialized = true;
      scans = data.sort((a,b) => {
        return new Date(b.date) - new Date(a.date);
      });
      
      if (!$dataStore) $dataStore = {};
      $dataStore['scans'] = scans;

      console.log('Scans:',scans);
    });

    if (!$noteStore) $noteStore = {};
    
    if ($dataStore.notes) $dataStore.notes = null;
    getData(`${config.defaultURL}/notes/${clientItem.id}`).then((data) => {
      notesInitialized = true;
      notes = data.sort((a,b) => {
        return new Date(b.date) - new Date(a.date);
      });
      
      if (!$dataStore) $dataStore = {};
      $dataStore['notes'] = notes;
      
      console.log('Notes:',notes);
    });

    if ($dataStore.transactions) $dataStore.transactions = null;
    getData(`${config.defaultURL}/transactions`).then((data) => {
      transactionsInitialized = true;
      transactions = data.sort((a,b) => {
        return new Date(b.date) - new Date(a.date);
      });

      clientTransactions = transactions.filter((item) => item.client_id == clientItem.id);      

      if (!$dataStore) $dataStore = {};
      $dataStore['transactions'] = transactions;

      console.log('transactions:',transactions);

      genTransactionCategories();
    });

    $scanStore = clientItem;

    formatPhone(payload.phone);
  }

  function closeModal() {
    document.getElementById('clientDetailsModal').classList.remove('is-active')
    // document.getElementById('clientDetailsModal').parentNode.removeChild(document.getElementById('clientDetailsModal'));
    if (!$clientStore) $clientStore = {}
    $clientStore['todo'] = 'getData';
  }

  function save() {
      console.log('payload', payload)

      updateData(`${config.defaultURL}/clients/update/` + clientItem.id, payload)
      .catch((error) => console.error('Failed to post client:', error))
      .then((res) => {
        console.log(res)
        closeModal()
      })
  }

  function genTransactionCategories() {
    const sorted = transactions.sort((a, b) => {
      const A = a.category ? a.category.toUpperCase() : null;
      const B = b.category ? b.category.toUpperCase() : null;
      if (A < B) return -1;
      if (B < A) return 1;
      return 0;
    });
    
    transactionCategories = [];
    
    sorted.forEach((item) => {
      if (item.category && transactionCategories.indexOf(item.category) == -1) transactionCategories.push(item.category);
    });
  }

  function editScanItem(item) {
    scan = item;
    scanSelected = true;
    
    openModal('editScanModal')
  }

  function editNoteModal(item) {
    console.log('note item',item);
    note = item;
    noteSelected = true;
    
    openModal('editNoteModal')
  }

  function editTransactionModal(item) {
    console.log('transaction item',item);
    transaction = item;
    transactionSelected = true;
    
    openModal('editTransactionModal')
  }

  // function deleteClient(item) {
  //       console.log('client:', item);
  //       openDeleteClientModal = true;
        
  //       openModal('deleteClientModal');
  // }
</script>

<style>
  .noData {
    margin: 0.5rem;
  }

  .flex {
      display: flex;
      justify-content: space-between;
      padding: 0.5rem;
  }

  .scanTable td,
  .noteTable td,
  .transactionTable td {
    cursor: pointer;
  }
</style>
  
<div on:show={displayClientDetails} class="modal is-active" id="clientDetailsModal" data-id="{dataId}">
  <div class="modal-background" />
  <div class="modal-card" style="width: 75vw">
    <header class="modal-card-head">
      <p class="modal-card-title">Client Details</p>
      <button on:click={closeModal} class="delete" aria-label="close" />
    </header>
    <section class="modal-card-body">
      <div class="columns">
        <div class="column">
          <h3>Contact Information</h3>
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">First</label>
            <input bind:value={payload.first} class="input" type="text" name="first" placeholder="First Name" />
          </div>
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Last</label>
            <input bind:value={payload.last} type="text" class="input" name="last" placeholder="Last Name" />
          </div>
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Email</label>
            <input bind:value={payload.email} type="email" class="input" name="email" placeholder="Email Address" />
          </div>
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Phone</label>
            <input bind:value={payload.phone} type="text" class="input" name="phone" placeholder="Phone Number" />
          </div>
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Street</label>
            <input bind:value={payload.street} type="text" class="input" name="street" placeholder="Street Address" />
          </div>
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">City</label>
            <input bind:value={payload.city} type="text" class="input" name="city" placeholder="City" />
          </div>
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">State</label>
            <input bind:value={payload.state} type="text" class="input" name="state" placeholder="State" />
          </div>
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Zip Code</label>
            <input bind:value={payload.zip} type="text" class="input" name="zip" placeholder="Zip Code" />
          </div>
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Birth Date</label>
            <input bind:value={payload.dob} type="text" class="input" name="dob" placeholder="Birth Date" />
          </div>
          <div class="flex">
            <div class="field is-grouped">
              <div class="control">
                <button on:click={save} class="button is-primary">Update</button>
              </div>
              <div class="control">
                <button on:click={closeModal} class="button is-primary is-light">Close</button>
              </div>
            </div>
            <!-- <div class="control">
              <button on:click={() => {deleteClient(clientItem.id)}} class="button is-danger">Delete</button>
            </div> -->
          </div>
        </div>
        <div class="column notification">
          <div class="flex">
            <div class="left">
              <h3>Notes</h3>
            </div>
            <div class="right">
              <button class="button is-primary" on:click={() => { openModal('addNoteModal') }}>
                <span class="icon">
                  <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z" />
                  </svg>
                </span>
                <span>Add Note</span>
              </button>
            </div>
          </div>
          {#if notesInitialized}
          <div class="table-container">
            <table class="noteTable table is-hoverable">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Note</th>
                </tr>
              </thead>
              <tbody>
                {#if notes.length}
                  {#each notes as item}
                    <tr id={item.id} on:click={() => { editNoteModal(item) } }>
                      <td>{(item.date) ? formatDate(item.date) : ''}</td>
                      <td>{item.note}</td>
                    </tr>
                  {/each}
                {:else}
                <div class="noData">No notes found for this client</div>
              {/if}
              </tbody>
            </table>
          </div>
          {:else}
          No notes found for this client
          {/if}

          <div class="flex">
            <div class="left">
              <h3>Scans</h3>
            </div>
            <div class="right">
              <button class="button is-primary" on:click={() => { openModal('addScanModal') }}>
                <span class="icon">
                  <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z" />
                  </svg>
                </span>
                <span>Add Scan</span>
              </button>
            </div>
          </div>
          {#if scansInitialized}
          <div class="table-container">
            <table class="scanTable table is-hoverable">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Follow Up</th>
                  <th>Report</th>
                </tr>
              </thead>
              <tbody>
                {#if scans.length}
                  {#each scans as item}
                    <tr id={item.id} on:click={ () => editScanItem(item) }>
                      <td>{formatDate(item.date)}</td>
                      <td style="text-transform: capitalize;">{item.type}</td>
                      <td style={(item.reminder_sent) ? 'color: #00d1b2; font-weight: 500;' : ''}>{(item.followup) ? formatDate(item.followup) : ''}</td>
                      {#if item.report}
                      <td style="text-align: center;"><svg style="height: 1.4rem;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z" /></svg></td>
                      {:else}
                      <td></td>
                      {/if}
                    </tr>
                  {/each}
                {:else}
                <div class="noData">No scans found for this client</div>
              {/if}
              </tbody>
            </table>
          </div>
          {:else}
          No scans found for this client
          {/if}

          <div class="flex">
            <div class="left">
              <h3>Transactions</h3>
            </div>
            <div class="right">
              <button class="button is-primary" on:click={() => { openModal('addTransactionModal') }}>
                <span class="icon">
                  <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z" />
                  </svg>
                </span>
                <span>Add Transaction</span>
              </button>
            </div>
          </div>
          {#if transactionsInitialized}
          <div class="table-container">
            <table class="transactionTable table is-hoverable">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Amount ($)</th>
                  <th>Description</th>
                  <th>Category</th>
                </tr>
              </thead>
              <tbody>
                {#if clientTransactions.length}
                {#each clientTransactions as item}
                <tr id={item.id} on:click={() => { editTransactionModal(item) }}>
                  <td>{formatDate(item.date)}</td>
                  <td>{item.amount}</td>
                  <td>{item.description}</td>
                  <td>{(item.category) ? item.category : ''}</td>
                </tr>
                {/each}
                {:else}
                <div class="noData">
                  No transactions found for this client
                </div>
                {/if}
              </tbody>
            </table>
          </div>
          {:else}
          <div class="noData">
            No transactions found for this client
          </div>
          {/if}
        </div>
      </div>
    </section>
  </div>
</div>
<AddScanModal />
{#if transactionCategories}
<AddTransactionModal categoryOptions={transactionCategories} />
{/if}
<AddNoteModal />

{#if scanSelected && scan}
<EditScanModal {scan} />
{/if}

{#if noteSelected && note}
<EditNoteModal {note} />
{/if}

{#if transactionSelected && transactionCategories && transaction}
<EditTransactionModal {transaction} categoryOptions={transactionCategories} />
{/if}

{#if openDeleteClientModal && clientItem}
<DeleteClientModal client={clientItem} />
{/if}